import { render, staticRenderFns } from "./ProgramSocForm.vue?vue&type=template&id=1df0efdb"
import script from "./ProgramSocForm.vue?vue&type=script&lang=js"
export * from "./ProgramSocForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports